const httpUrl = window.location.host;
export default {
    baseURL: {
        // 正式环境
        pro: 'https://api.yanglao365.org.cn/api',
        url: 'http://59.110.24.172:8024'
    }
}
